<template>
  <div class="mypage-home">
    <TitleLogo :title="$t('page.mypage.title')" />

    <!-- 목록 -->
    <v-sheet>
      <!-- 탭 제목: 주소의 ?type= 을 따라간다. 세 칸 고정이라 글꼴·언어가 바뀌어도 밀리지 않는다 -->
      <nav class="mypage-tabs" role="tablist" :lang="$domLang">
        <button
          v-for="(tab, index) in tabs"
          :key="tab.type"
          type="button"
          role="tab"
          class="mypage-tabs__tab"
          :class="{ 'mypage-tabs__tab--active': index === tabIndex }"
          :aria-selected="String(index === tabIndex)"
          @click="selectTab(index)"
        >
          {{ $t(tab.title) }}
        </button>
      </nav>

      <!-- 탭 본문 -->
      <v-tabs-items :value="tabIndex">
        <v-tab-item>
          <PurchaseHistory ref="reservation" />
        </v-tab-item>
        <v-tab-item>
          <MyPicture ref="picture" />
        </v-tab-item>
        <v-tab-item>
          <Update ref="account" />
        </v-tab-item>
      </v-tabs-items>
    </v-sheet>
  </div>
</template>
<script>
import MyPicture from "./components/MyPicture"
import PurchaseHistory from "./components/PurchaseHistory"
import Update from "./components/Update"
import TitleLogo from "@/views/components/TitleLogo"

// 로그인 확인은 라우터(mypage: requiresAuth)가 한다.
const TABS = [
  { type: "reservation", title: "page.mypage.tab-title-payHistory" },
  { type: "picture", title: "page.mypage.tab-title-album" },
  { type: "account", title: "page.mypage.tab-title-account" },
]

export default {
  components: {
    MyPicture,
    TitleLogo,
    PurchaseHistory,
    Update,
  },

  data: () => ({
    tabs: TABS,
  }),

  computed: {
    tabIndex() {
      const index = TABS.findIndex((tab) => tab.type === this.$route.query.type)
      return index >= 0 ? index : 0
    },
  },

  watch: {
    // 다른 탭에서 돌아오면 최신 내용으로 다시 불러온다(처음 여는 탭은 스스로 불러옴)
    tabIndex(index) {
      this.$nextTick(() => this.$refs[TABS[index].type]?.load?.())
    },
  },

  methods: {
    selectTab(index) {
      const type = TABS[index]?.type
      if (!type || type === this.$route.query.type) return
      this.$router.replace({ query: { ...this.$route.query, type } }).catch(() => {})
    },
  },
}
</script>
<style scoped>
/* 떠 있는 하단 메뉴(홈·오시는 길)에 마지막 내용이 가리지 않게 */
.mypage-home {
  padding-bottom: calc(104px + env(safe-area-inset-bottom));
}
.mypage-tabs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border-bottom: 1px solid rgba(189, 155, 92, 0.28);
  font-family: "NanumSquare", sans-serif;
}
.mypage-tabs:lang(ja) {
  font-family: "Noto Sans JP", sans-serif;
}
.mypage-tabs__tab {
  min-width: 0;
  min-height: 48px;
  padding: 0 4px;
  color: #8e7d78;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  cursor: pointer;
}
.mypage-tabs__tab--active {
  color: #5f4844;
  font-weight: 800;
  border-bottom-color: #d74369;
}
.mypage-tabs__tab:focus-visible {
  outline: 2px solid rgba(215, 67, 105, 0.45);
  outline-offset: -2px;
}
</style>
